document.addEventListener('DOMContentLoaded', function () {
  const modalElement = document.getElementById('notify-nearby-firefighters-modal');

  if (!modalElement) return;

  document.querySelectorAll('.notify-nearby-firefighters-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();

      const url = this.dataset.url;

      const modal = modalElement.cloneNode(true);
      modal.style.display = 'block';
      document.body.appendChild(modal);

      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

      function submitForm() {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = url;

        if (csrfToken) {
          const csrfInput = document.createElement('input');
          csrfInput.type = 'hidden';
          csrfInput.name = 'authenticity_token';
          csrfInput.value = csrfToken;
          form.appendChild(csrfInput);
        }

        document.body.appendChild(form);
        form.submit();
      }

      modal.querySelector('.cancel-notify-btn').addEventListener('click', function () {
        modal.remove();
      });

      modal.querySelector('.confirm-notify-btn').addEventListener('click', function () {
        this.disabled = true;
        this.textContent = 'Notifying...';
        submitForm();
      });

      const overlay = modal.querySelector('.modal-overlay');
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
          modal.remove();
        }
      });
    });
  });
});
